import { ENV_CONSTANT } from './enums';

/* ToDo: Add back once prod and guardian in place:
export const BaseRoute =
  process.env.REACT_APP_ENV == ENV_CONSTANT.PRODUCTION ? '/webportal' : '/prepaywebportalui';
*/
export const BaseRoute = '/ui';
export const ClaimsPrepayRoute = `${BaseRoute}/claims/prepay`;
export const ClaimsPaidRoute = `${BaseRoute}/claims/paid`;
export const AppealsRoute = `${BaseRoute}/appeals`;
export const InquiriesRoute = `${BaseRoute}/inquiries`;
export const DocumentsRoute = `${BaseRoute}/documents`;
export const InvoicingRoute = `${BaseRoute}/invoicing`;
export const CreateInvoicesRoute = `${BaseRoute}/invoicing/create-invoices`;
export const InvoiceSearchRoute = `${BaseRoute}/invoicing/invoice-search`;
export const HelpandSupportRoute = `${BaseRoute}/support`;
export const PrivacyNoticeRoute = `${BaseRoute}/privacy-notice`;
export const TermsOfUseRoute = `${BaseRoute}/terms-of-use`;
export const RulesRoute = `${BaseRoute}/rule-spec/rules`;
export const ReasonCodesRoute = `${BaseRoute}/rule-spec/reason-codes`;
export const DocumentReferencesRoute = `${BaseRoute}/rule-spec/document-references`;
export const ClientsRoute = `${BaseRoute}/client-management/clients`;
export const AppealResponsesRoute = `${BaseRoute}/appeal-responses`;
export const ActivityLogRoute = `${BaseRoute}/activity-log`;
export const MyRecentActivitiesRoute = `${BaseRoute}/my-recent-activities`;
